/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faCopy } from '@fortawesome/pro-duotone-svg-icons';

// actions
import { getPermissions } from '../../../../actions/permissions';

// components
import { Table } from '../../../../common/components';

function StatePermissions() {
  const { records: data = [] } = useSelector(store => store.permissions.state);
  const {
    carriers,
    user: profileUser = {},
    agents: { selectedAgent = {} },
  } = useSelector(store => store);
  const { username: agentUsername } = selectedAgent;
  const { username: profileUsername } = profileUser;
  const [ loading, setLoading ] = useState(false);

  // cell formatting
  const formatDateTimeCell = (date) => moment(date).format('MM/DD/YYYY hh:mm A');
  const formatDateCell = (date) => moment(date).format('MM/DD/YYYY');
  const formatCarrierCell = (cid) => carriers[cid];
  const formatActiveCell = (active) => (active
    ? <FontAwesomeIcon className="text-success" icon={faCheck} />
    : <FontAwesomeIcon className="text-danger" icon={faTimes} />
  );

  useEffect(() => {
    setLoading(true);
    getPermissions(agentUsername || profileUsername, 'state')
      .finally(() => setLoading(false));
  }, []);

  const tableSchema = {
    cols: [
      { header: 'State', field: 'state' },
      { header: 'First Name', field: 'first_name' },
      { header: 'Last Name', field: 'last_name' },
      { header: 'Issue Date', field: 'issued', formatter: formatDateCell },
      { header: 'Expiration Date', field: 'expiration_date', formatter: formatDateCell },
      { header: 'License #', field: 'license' },
      { header: 'Status', field: 'active', formatter: formatActiveCell },
      { header: 'Last Changed', field: 'updated', formatter: formatDateTimeCell },
    ],
  };

  return (
    <div className="bg-white border">
      <div className="row mt-3">
        <div className="col">
          <Table
            loading={loading}
            className="table table-striped"
            schema={tableSchema}
            data={data}
          />
        </div>
      </div>
    </div>
  );
}

export default StatePermissions;
